import { useState } from "react";
import { apiSend, errorMessage } from "./api";
import "./CreateUserModal.css";

function CreateOrgModal({ onClose, onCreated }) {
  const [name, setName] = useState("");
  const [siret, setSiret] = useState("");
  const [inviteEmail, setInviteEmail] = useState("");
  const [error, setError] = useState("");
  const [warning, setWarning] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setWarning("");
    setLoading(true);
    try {
      const res = await apiSend("/api/organizations", "POST",
        { name, invite_email: inviteEmail.trim() || null, siret: siret.trim() || null },
        "Erreur lors de la création");
      // L'organisation peut être créée alors que l'e-mail n'est pas parti :
      // on garde la modale ouverte pour le signaler, sinon l'échec passerait
      // inaperçu et personne ne relancerait le commerçant.
      if (res.invite_error) {
        setWarning(res.invite_error);
        setLoading(false);
        return;
      }
      onCreated();
      return;
    } catch (e) {
      setError(errorMessage(e, "Erreur lors de la création"));
    }
    setLoading(false);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Créer une organisation</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <form onSubmit={handleSubmit}>
          {error && <div className="modal-error">{error}</div>}
          {warning && (
            <div className="modal-error">
              {warning}
              <button type="button" className="modal-warning-close" onClick={onCreated}>
                Fermer
              </button>
            </div>
          )}
          <label>Nom de l'organisation</label>
          <input value={name} onChange={(e) => setName(e.target.value)} required />
          <label>SIRET (facultatif)</label>
          <input
            value={siret}
            onChange={(e) => setSiret(e.target.value)}
            inputMode="numeric"
            placeholder="123 456 789 00012"
            maxLength={20}
          />
          <p className="modal-hint">
            14 chiffres. S'il n'est pas connu, le gérant le renseignera
            lui-même à la création de son compte.
          </p>
          <label>E-mail du gérant (facultatif)</label>
          <input
            type="email"
            value={inviteEmail}
            onChange={(e) => setInviteEmail(e.target.value)}
            placeholder="gerant@commerce.fr"
          />
          <p className="modal-hint">
            Si renseigné, un lien de création de compte lui est envoyé
            immédiatement. Il est valable 7 jours et ne sert qu'une fois.
          </p>
          <button type="submit" className="modal-submit" disabled={loading}>
            {loading ? "Création..." : "Créer"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default CreateOrgModal;
